export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const GOOGLE_LOGIN_REQUEST = 'LOGIN_REQUEST';
export const GOOGLE_LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const GOOGLE_LOGIN_FAILURE = 'LOGIN_FAILURE';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const GET_PROFILE_REUEST='GET_PROFILE_REUEST'
export const GET_PROFILE_SUCCESS='GET_PROFILE_SUCCESS'
export const GET_PROFILE_FAILURE='GET_PROFILE_FAILURE'

export const UPDATE_USER_REQUEST='UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS='UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE='UPDATE_USER_FAILURE';

export const FIND_USER_BY_ID_REQUEST='FIND_USER_BY_ID_REQUEST';
export const FIND_USER_BY_ID_SUCCESS='FIND_USER_BY_ID_SUCCESS';
export const FIND_USER_BY_ID_FILURE='FIND_USER_BY_ID_FILURE';

export const FOLLOW_USER_REQUEST="FOLLOW_USER_REQUEST";
export const FOLLOW_USER_SUCCESS='FOLLOW_USER_SUCCESS';
export const FOLLOW_USER_FAILURE='FOLLOW_USER_FAILURE';


export const SEARCH_USER_REQUEST="SEARCH_USER_REQUEST";
export const SEARCH_USER_SUCCESS='SEARCH_USER_SUCCESS';
export const SEARCH_USER_FAILURE='SEARCH_USER_FAILURE';

export const REQUEST_RESET_PASSWORD_REQUEST="REQUEST_RESET_PASSWORD_REQUEST";
export const REQUEST_RESET_PASSWORD_SUCCESS='REQUEST_RESET_PASSWORD_SUCCESS';
export const REQUEST_RESET_PASSWORD_FAILURE='REQUEST_RESET_PASSWORD_FAILURE';

export const RESET_PASSWORD_REQUEST="RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS='RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE='RESET_PASSWORD_FAILURE';


export const LOGOUT="LOGOUT";